import { useCallback, useRef } from 'react'

export const useKeyGenerator = () => {
	const keyRef = useRef(0)

	return useCallback((prefix = '') => prefix + keyRef.current++, [])
}
